import type { Root } from 'hast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

export const rehypeNormalizeCodeBlock: Plugin<[], Root> = function () {
  return function (tree) {
    visit(tree, 'text', (node, index, parent) => {
      if (
        parent &&
        typeof index === 'number' &&
        parent.type === 'element' &&
        parent.tagName === 'code' &&
        node.value.endsWith('\n')
      ) {
        node.value = node.value.slice(0, -1);
      }
    });
  };
};

export default rehypeNormalizeCodeBlock;
